import { Component } from '@angular/core';

@Component({
  selector: 'header-logo',
  templateUrl: './header-logo.component.html'
})
export class HeaderLogoComponent {}
